module.exports = __webpack_public_path__ + "static/media/cocina.cda2bd5e.jpg";